import { Component, OnInit, Input, ContentChild, TemplateRef, Output, EventEmitter, AfterViewInit, ViewChild,  } from '@angular/core';
declare var $: any;

@Component({
  selector: 'sw-guided-steps',
  templateUrl: './sw-guided-steps.component.html',
  styleUrls: ['./sw-guided-steps.component.css']
})
export class SwGuidedStepsComponent implements OnInit {
  /**
   * stepsDatas 为导向式组件数据
   */
  @Input() stepsDatas: any = []
   /**
   * stepsType为导向式组件样式类型
   * 样式类型1： 有步骤数字、标题、和描述（其中标题和描述可省略） ==>步骤、标题和描述为上下布局   方向从左向右
   * 样式类型2： 有步骤数字、标题 ==>步骤和标题为左右布局 方向从左向右
   * 样式类型3： 有步骤数字、标题（标题为待完成、已完成、进行中三种静态数据） ==>步骤和标题为左右布局 方向从左向右
   * 样式类型4： 有步骤数字、标题 ==>步骤和标题为左右布局 方向从上向下
   */
  @Input() stepsType:number = 1
  /**
   * position 为导向式组件当前位置
   */
  @Input() position:number = 0
 
  /**
   * width 为每一个步骤的宽度
   */
  width:string = '0%';

     /**
   * isDisplayNum 为导向式组件是否显示步骤数字（只有类型5有该功能）
   */
      @Input() isDisplayNum:boolean = true

       /**
   * isCanClick 为导向式组件是否可点击  （只有类型5有该功能）
   */
  @Input() isCanClick:boolean = true
   /**
   * 组件的id
   * @ignore
   */
  idt: string;

   /**
  * 抛出position（只有类型5有该功能）
  */
 @Output() outPosition = new EventEmitter();

  constructor() { }

  ngOnInit() {
    //计算每一个条目的宽度
    this.width = 100 / this.stepsDatas.length + '%'
    //获取随机id
    this.idt = "step" + Math.random().toString().split(".")[1];
  }

  clickType5(index,num){
    if(this.isCanClick){
      this.position = num
      this.outPosition.emit(this.position)
    }
  }
}
